import React from "react";
import ConfigurationPage from "templates/ConfigurationPage";
import ResidentContent from "./ResidentContent";

const EditResident = (props) => {
 const {history} = props;
 
    return (
        <ConfigurationPage
            history={history}
            pageTitle="Residents"
            pageSubTitle="Edit resident"
        >
            <ConfigurationPage.Content>
                <ResidentContent {...props}/>
            </ConfigurationPage.Content>
        </ConfigurationPage>
    );
};

export default EditResident;